export default __webpack_public_path__ + "static/kontakta-oss-b0ca3d90cf9bd6f784d63d9bebf893d2.svg";